<template>
  <div class="page-box">
    <div class="login-box">
      <img src="@/assets/images/logo4.png" />
      <div class="input-li">
        <div class="input-title">手机号</div>
        <div class="input-box">
          <el-input v-model="phone" :class="{ 'is-error': phoneError }" placeholder="请输入手机号" maxlength="11"
            @blur="validatePhone"></el-input>
          <div v-if="phoneError" class="error-tip">{{ phoneError }}</div>
        </div>
      </div>
      <div class="input-li">
        <div class="input-title">图片验证码</div>
        <div class="input-code-box">
          <div class="input-box">
            <el-input v-model="captcha" @blur="validateCaptcha" :class="{ 'is-error': captchaError }" maxlength="4"
              placeholder="请输入图片验证码">
              <template slot="suffix">
                <div class="input-code-img" @click="getCode">
                  <img class="code-img" v-if="codeInfo.base64Image" :src="codeInfo.base64Image" alt="">
                </div>
              </template>
            </el-input>
            <div v-if="captchaError" class="error-tip">{{ captchaError }}</div>
          </div>
        </div>
      </div>
      <div class="input-li">
        <div class="input-title">验证码</div>
        <div class="input-code-box">
          <div class="input-box">
            <el-input v-model="code" maxlength="4" placeholder="请输入验证码"></el-input>
          </div>
          <div class="input-code-text" @click="startCountdown">
            {{ countdownText }}
          </div>
        </div>
      </div>
      <div><el-button type="primary" :disabled="isDisabled()" @click="onClickLogin">登录</el-button></div>
      <div class="code-login-text" @click="onClickRoute">密码登录</div>
    </div>
  </div>
</template>

<script>
import { sendLoginCode, codeLogin, getCode } from '@/api/login'
import { getCurrentUser } from '@/api/user'
import { setJSEncrypt } from '@/util/index.js'

export default {
  name: "login",
  data() {
    return {
      phone: '',
      password: '',
      code: '',
      captcha: '',
      phoneError: '', // <-- 新增：用于显示手机号错误信息
      captchaError: '',
      codeImg: '',
      uuid: '',
      countdown: 60, // 倒计时总时间（秒）
      isCounting: false, // 是否正在倒计时
      countdownText: '获取验证码',
      codeInfo: {}, // 图片验证码
    }
  },
  mounted() {
    this.getCode()
  },
  methods: {
    validatePhone() {
      const phoneReg = /^1[3-9]\d{9}$/
      if (!this.phone) {
        this.phoneError = '请输入手机号！'
      } else if (!phoneReg.test(this.phone)) {
        this.phoneError = '请输入正确的11位手机号'
      } else {
        this.phoneError = ''
      }
    },
    validateCaptcha() {
      if (!this.captcha) {
        this.captchaError = '请输入图片验证码！'
      } else {
        this.captchaError = ''
      }
    },
    startCountdown() {
      const phoneReg = /^1[3-9]\d{9}$/
      if (!this.phone) {
        this.phoneError = '请输入手机号！'
        return
      } else if (!phoneReg.test(this.phone)) {
        this.phoneError = '请输入正确的11位手机号'
        return
      } else {
        this.phoneError = '' // 校验通过清空错误提示
      }

      if (!this.captcha) {
        this.captchaError = '请输入图片验证码！'
        return
      } else {
        this.captchaError = ''
      }

      if (!this.isCounting) {
        this.sendLoginCode()
      }

    },
    stopCountdown() {
      clearInterval(this.timer); // 清除定时器
      this.countdownText = "获取验证码"
      this.isCounting = false; // 重置状态为非倒计时中
      this.countdown = 60; // 重置倒计时秒数，可根据需要调整为其他值或者不重置
    },
    onClickRoute() {
      this.$router.replace({ path: `/login` })
    },
    // 点击登录
    onClickLogin() {
      this.codeLogin()
    },
    // 手机验证码登录：发送验证码
    sendLoginCode() {
      sendLoginCode({
        phone: this.phone,
        uuid: this.codeInfo.uuid,
        captcha: this.captcha,
      }).then(async res => {
        if (res.code != 'A00000') {
          this.$message.error(res.message);
        } else {
          this.isCounting = true
          this.countdown = 60
          this.countdownText = `${this.countdown}秒后重新获取`

          this.timer = setInterval(() => {
            if (this.countdown > 0) {
              this.countdown -= 1
              this.countdownText = `${this.countdown}秒后重新获取`
            } else {
              this.stopCountdown()
            }
          }, 1000)

        }
      })
    },
    // 获取图片验证码
    getCode() {
      getCode().then(async res => {
        if (res.code == 'A00000') {
          this.codeInfo = res.data[0]
        }
      })
    },
    // 账号密码登录，返回token
    codeLogin() {
      codeLogin({
        phone: this.phone,
        code: this.code,
        client: 'OM_PC',
      }).then(async res => {
        if (res.code == 'A00000') {
          localStorage.setItem("x-token", res.extras['x-token'])
          await this.getCurrentUser()
          this.$router.push({ path: `/` })
        } else {
          this.$message.warning(res.message);
        }
      })
    },
    // 获取当前登录用户
    async getCurrentUser() {
      await getCurrentUser().then(res => {
        if (res.code == 'A00000') {
          localStorage.setItem("userInfo", JSON.stringify(res.data[0]))
        }
      })
    },
    isDisabled() {
      if (this.phone == "" || this.code == "") {
        return true
      }
      return false
    }
  }
}
</script>

<style scoped lang="less">
.error-tip {
  color: #BD181E;
  font-size: 14px;
  line-height: 14px;
  margin-top: 10px;
}

.page-box {
  background: url("~@/assets/images/logo-bg.jpg") no-repeat;
  background-size: 100% 100%;
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/deep/.is-error .el-input__inner {
  border-color: red !important;
}

.code-login-text {
  margin-top: 10px;
  font-size: 16px;
  color: #BD181E;
  cursor: pointer;
}

.login-box>img {
  margin-bottom: 40px;
  width: 340px;
}

.login-box {
  background: #fff;
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  width: 640px;
  min-height: 710px;
  padding: 42px 92px 20px 92px;
  box-sizing: border-box;

  /deep/.el-button {
    width: 100%;
    border: none;
    background: rgba(156, 29, 34, 1);
    height: 54px;
    font-size: 16px;
    margin-top: 20px;
  }
}

.input-box {
  position: relative;
}

.input-code-img {
  width: 100px;
  height: 100%;
  display: flex;
  align-items: center;

  .code-img {
    width: 100px;
    height: 40px;
    vertical-align: bottom;
    cursor: pointer;
  }
}

.input-li {
  text-align: left;
  margin-bottom: 20px;

  .verification {
    position: absolute;
    width: 100px;
    height: 40px;
    background: #eee;
    right: 5px;
    top: 7px;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      vertical-align: bottom;
    }
  }

  /deep/.el-input__inner {
    border: 1px solid rgba(220, 223, 230, 1);
    height: 54px;
    font-size: 14px;
  }

  .input-title {
    font-size: 20px;
    margin-bottom: 12px;
    font-weight: bold;
    line-height: 28px;
  }

  .input-code-box {
    display: flex;
    align-items: center;

    .input-box {
      flex: 1;
      overflow: hidden;
    }
  }

  .input-code-text {
    border: 1px solid #BD181E;
    border-radius: 4px;
    color: #BD181E;
    font-size: 16px;
    margin-left: 12px;
    height: 54px;
    box-sizing: border-box;
    line-height: 54px;
    text-align: center;
    padding: 0 16px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Login/codeLogin.vue